<script setup lang="ts">
  import { ref, computed, inject } from 'vue'
  const props = defineProps({
    error: {
      type: Object,
      default: () => ({})
    }
  })
  const page_not_found = ref('The page you are looking for can not be found')
  const other_error = ref('An error occurred')
  const title = computed(() =>
    props.error.statusCode === 404 ? page_not_found.value : other_error.value
  )
  inject('title', title)
</script>

<template>
  <v-app>
    <h1 class="text-h2 px-8 pt-4">
      <span>{{ error.status_code }}:</span>
      <span v-if="error.status_code === 404">{{ page_not_found }}</span>
      <span v-else>{{ other_error }}</span>
    </h1>
    <p class="text-h5 pa-8">
      {{ error.message }}
    </p>
  </v-app>
</template>

<style scoped>
  h1 {
    font-size: 20px;
  }
</style>
